import { lazy, Suspense } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// NOTE: Keep toasters as direct imports.
// Lazy-loaded chunks can fail to resolve after hot rebuilds / cached chunk maps,
// causing a blank screen with "Failed to fetch dynamically imported module".
import { Toaster } from "@/components/ui/toaster";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DomainConfigProvider } from "./contexts/DomainConfigContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import Index from "./pages/Index";
import RouteLoading from "@/components/RouteLoading";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Lazy load non-critical routes
const AboutUs = lazy(() => import("./pages/AboutUs"));
const International = lazy(() => import("./pages/International"));
const FAQs = lazy(() => import("./pages/FAQs"));
const Blogs = lazy(() => import("./pages/Blogs"));
const BlogDetail = lazy(() => import("./pages/BlogDetail"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const SelectParking = lazy(() => import("./pages/SelectParking"));
const BookingProfile = lazy(() => import("./pages/BookingProfile"));
const BookingConfirm = lazy(() => import("./pages/BookingConfirm"));
const BookingSuccess = lazy(() => import("./pages/BookingSuccess"));
const BookingCancelled = lazy(() => import("./pages/BookingCancelled"));
const Terms = lazy(() => import("./pages/Terms"));
const Privacy = lazy(() => import("./pages/Privacy"));
const TestimonialsPage = lazy(() => import("./pages/TestimonialsPage"));
const NotFound = lazy(() => import("./pages/NotFound"));
const queryClient = new QueryClient();
const App = () => (
  <QueryClientProvider client={queryClient}>
    <DomainConfigProvider>
      <LanguageProvider>
        <TooltipProvider>
          <Suspense fallback={null}>
            <Toaster />
            <Sonner />            <ToastContainer />
            <ToastContainer />
          </Suspense>
          <BrowserRouter>
            <Suspense fallback={<RouteLoading label="Loading page…" />}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/international" element={<International />} />
                <Route path="/faqs" element={<FAQs />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/blog/:slug" element={<BlogDetail />} />
                <Route path="/contact" element={<ContactUs />} />
                
                <Route path="/select-parking" element={<SelectParking />} />
                <Route path="/booking/profile" element={<BookingProfile />} />
                <Route path="/booking/confirm" element={<BookingConfirm />} />
                <Route path="/booking/cancel" element={<BookingCancelled />} />
                <Route path="/booking/success" element={<BookingSuccess />} />
                <Route path="/thankyou" element={<BookingSuccess />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/testimonials" element={<TestimonialsPage />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </TooltipProvider>
      </LanguageProvider>
    </DomainConfigProvider>
  </QueryClientProvider>
);
export default App;
